import React from "react";
import AddIcon from "../UIComponents/AddIcon";
import { Trans, withTranslation } from "react-i18next";
import { Translation } from "react-i18next";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import {
  getCDocFolderList,
  getCDocFilesList,
  deleteCDocFolder,
} from "../Actions/ControlledDocAPI";
import ControlledDocCard from "./ControlledDocCard";
import { toast } from "react-toastify";
import { confirmAlert } from "react-confirm-alert";
import $ from "jquery";

let currentuser = JSON.parse(localStorage.getItem("currentUser"));

class ControlledDocuments extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchData: {
        FolderName: "",
        PageNumber: 1,
        PageSize: 20
      }
    }
    console.log(props);
    this.SearchDoc = this.SearchDoc.bind(this);
    this.ClearInput = this.ClearInput.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  componentDidMount() {
    const { dispatch, docSearch, t } = this.props;
    if (docSearch) {
      this.state.searchData = docSearch;
    }
    dispatch(getCDocFolderList(this.state.searchData));
    dispatch({ type: 'SubBannerTitle', data: "Controlled Documents" });
  }

  SearchDoc(pgno) {
    const { dispatch } = this.props;
    this.state.searchData.PageNumber = pgno;
    dispatch({ type: "docSearch", data: this.state.searchData });
    dispatch(getCDocFolderList(this.state.searchData));
  }

  handleInputChange(e) {
    this.state.searchData.FolderName = e.target.value;
    this.setState({});
  }

  eyeclick(item) {
    const { dispatch, history } = this.props;
    history.push(`/Home/ControlledDocumentsView/${item.folderId}/Files`);
  }

  ClearInput() {
    this.setState({
      searchData: {
        FolderName: "",
        FileName: "",
        PageNumber: 1,
        PageSize: 20
      }
    });
    this.props.dispatch({ type: "docSearch", data: this.state.searchData });
    this.props.dispatch(getCDocFolderList(this.state.searchData));
  }

  NewitemNav = () => {
    this.props.dispatch({ type: "ShowSidePan", data: true });
    this.props.history.push("/Home/ControlledDocumentsAdd");
    // this.props.dispatch({ type: "DocApplicableServices", data: "" });
  }

  componentDidMount() {
    const { dispatch, docSearch, t } = this.props;
    if (docSearch) {
      this.state.searchData = docSearch;
    }
    dispatch(getCDocFolderList(this.state.searchData));
    dispatch({ type: "SubBannerTitle", data: "Controlled Documents" });
    let searchitem = this.state.searchData;
    let _this = this;
    this.keyPressHandler = function (event) {
      var keycode = event.keyCode || event.which;

      if (keycode === 13) {
        if (searchitem.FolderName != "") {
          _this.SearchDoc(1);
        }
        else {
          toast.success(t('Toast.Success'), {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
      }
    }

    $(document).keypress(this.keyPressHandler);
  }

  componentWillUnmount() {

    $(document).off("keypress", this.keyPressHandler);
  }

  SearchDoc(pgno) {
    const { dispatch } = this.props;
    this.state.searchData.PageNumber = pgno;
    dispatch({ type: "docSearch", data: this.state.searchData });
    dispatch(getCDocFolderList(this.state.searchData));
  }

  deleteFolder(item) {
    const { t } = this.props;
    confirmAlert({
      message: `${t("confirmAlertMessage.DeleteMsg")}`,
      buttons: [
        {
          label: `${t("confirmAlertMessage.Yes")}`,
          onClick: () => {
            const { dispatch } = this.props;
            dispatch(deleteCDocFolder(item));
            this.ClearInput()
          }
        },
        {
          label: `${t("confirmAlertMessage.No")}`,
          onClick: () => { }
        }
      ]
    });
  }

  SearchDoc1(pgno) {
    if (this.state.searchData.FolderName !== "") {
      const { dispatch } = this.props;
      this.state.searchData.PageNumber = pgno;
      dispatch({ type: "docSearch", data: this.state.searchData });
      dispatch(getCDocFolderList(this.state.searchData));
    }
    else {
      toast.success("Please select atleast one value", {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  }

  handleInputChange(e) {
    this.state.searchData.FolderName = e.target.value;
    this.setState({});
  }

  eyeclick(item) {
    const { dispatch, history } = this.props;
    history.push(`/Home/ControlledDocumentsView/${item.folderId}/Files`);
  }

  ClearInput() {
    this.state.searchData.FolderName = "";
    this.state.searchData.FileName = "";
    this.setState({});
    /*   this.setState({
        searchData: {
          FolderName: "",
          FileName: "",
          PageNumber: 1,
          PageSize: 20,
        },
      }); */
    this.props.dispatch({ type: "docSearch", data: this.state.searchData });
    this.props.dispatch(getCDocFolderList(this.state.searchData));
  }

  NewitemNav = () => {
    this.props.dispatch({ type: "ShowSidePan", data: true });
    this.props.history.push("/Home/ControlledDocumentsAdd");
    // this.props.dispatch({ type: "DocApplicableServices", data: "" });
  };

  render() {
    const { showSidePane, CDocFolderList, t } = this.props;
    // console.log("", CDocFolderList)
    return (
      <div className="full-height">
        <div className="pt-3">
          <div className="row">
            <div className={showSidePane ? "col-lg-6" : "col-lg-12"}>
              <div className="row">
                <div className="col-lg-12">
                  <div className="panel-box">
                    <div
                      className="card MM-card-header mb-0"
                      style={{ backgroundColor: "white" }}
                    >
                      <div
                        className="card-body flex"
                        style={{
                          padding: "0rem",
                          backgroundColor: "#1a3464",
                          color: "white",
                        }}
                      >
                        <h5
                          className="card-title ml-2 mt-2 f2"
                          style={{ color: "092a51" }}
                        >
                          {t("ControlledDocumentsScreenContent.Title")}
                        </h5>
                        <div className="m-1 flex" onClick={this.NewitemNav}>
                          <span className="mt-1">{t("ShipManagementContent.Add")}</span>
                          <AddIcon />
                        </div>
                      </div>
                    </div>
                    <div className="search-filter-box">
                      <div className="row">
                        <div className={"col-lg-6"}>
                          <label className="form-label">{t("ControlledDocumentsScreenContent.Folder")} / {t("ControlledDocumentsScreenContent.File")}</label>
                          <br></br>
                          <input
                            className="form-control"
                            type="text"
                            value={this.state.searchData.FolderName}
                            placeholder={t("ControlledDocumentsScreenContent.Folder")}
                            onChange={(e) => this.handleInputChange(e)}
                          ></input>
                        </div>
                        <div className={"col-lg-6"}>
                          <br></br>
                          <div
                            className="form-group search-btn-col pt-3"
                            style={{ textAlign: "end" }}
                          >
                            <button
                              className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                              type="submit"
                              onClick={() => this.SearchDoc1(1)}
                            >
                              {" "}
                              {t("content.Search")}{" "}
                            </button>
                            <button
                              className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                              type="button"
                              onClick={() => this.ClearInput()}
                            >
                              {" "}
                              {t("content.Clear")}{" "}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {CDocFolderList ? (
                <ControlledDocCard
                  currentPage={(CDocFolderList.pagination?.currentPage - 1) * CDocFolderList.pagination?.pageSize}
                  arraylist={CDocFolderList.data}
                  totalRecords={
                    CDocFolderList.pagination
                      ? CDocFolderList.pagination.totalcount
                      : 0
                  }
                  pageSize={CDocFolderList.pagination?.pageSize}
                  setUpdatedState={(value) => this.SearchDoc(value)}
                  eyeclick={(item) => this.eyeclick(item)}
                  deleteFolder={(item) => this.deleteFolder(item)}
                />
              ) : null}
            </div>
          </div>
        </div>
      </div>
    );
  }
  openEditScreen() {
    this.props.dispatch({ type: "ShowSidePan", data: false });
    this.props.history.push("/Home/EditClient");
  }
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}
function mapStateToProps(state) {
  return {
    showSidePane: state.SidePanReducer.sidePan,
    CDocFolderList: state.ControlledDocReducer.CDocFolderList || [],
    docSearch: state.ControlledDocReducer.docSearch,
  };
}
export default withTranslation()(withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ControlledDocuments)));
